// Keys used to store stuff to session/local storage

export const storageKeys = {
  STOCK_DISPLAY_MODE: 'STOCK_DISPLAY_MODE',
  STOCK_VIEW_TYPE: 'STOCK_VIEW_TYPE',
  LAST_STOCK_URL: 'LAST_STOCK_URL',
  SELECTED_LOCATION_ID: 'SELECTED_LOCATION_ID',
  UCC_NEWS_ITEM: 'UCC_NEWS_ITEM',
  UCC_PREFERRED_LANGUAGE: 'UCC_PREFERRED_LANGUAGE',
}
